import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DigitOnlyDirective} from './digit-only.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [DigitOnlyDirective],
  exports: [DigitOnlyDirective]
})
export class DigitOnlyModule {}
